import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=738b2088&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=738b2088&prod&scoped=true&lang=scss"
import style1 from "./EmailTemplates.vue?vue&type=style&index=1&id=738b2088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b2088",
  null
  
)

export default component.exports